import { render } from "./HormoneZoomerPage.vue?vue&type=template&id=6408de5c"
import script from "./HormoneZoomerPage.vue?vue&type=script&lang=js"
export * from "./HormoneZoomerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__